// 设置动态切换主题
import React, {useEffect, useState} from "react";
import {ThemeImgUrlType} from "./theme_imgs.ts";
import {BASE_NAME} from "../../common/constants.ts";
import {ThemeContext} from "./theme-context.tsx";
import {IThemeSetting} from "../../common/utils/http/IResponse.ts";
import {apiService} from "../../common/utils/http/api-service.ts";
import debounce from "lodash/debounce";

function ThemeProvider({children}: { children: React.ReactNode }) {
    const localTheme = 'theme-default';

    // 后台设置的主题配置
    const [theme, setTheme] = useState<IThemeSetting | null>(null);

    const commonUrl = "common";

    // 定义图片地址
    const images: ThemeImgUrlType = {
        loginBgImgUrl: `${BASE_NAME}/${localTheme}/images/login/bg.webp`,
        privacyCheckedIconUrl: `${BASE_NAME}/${localTheme}/images/login/login_checked_icon.webp`,
        privacyUnCheckedIconUrl: `${BASE_NAME}/${localTheme}/images/login/login_check_circle.webp`,
        titleBarBgUrl: `${BASE_NAME}/${localTheme}/images/home/home_title_bg.webp`,
        dailyCalendarIconUrl: `${BASE_NAME}/${localTheme}/images/home/home_daily_calendar_fill.webp`,
        gameTipIconUrl: `${BASE_NAME}/${localTheme}/images/game/game_tip_btn.webp`,
        challengeIconUrl: `${BASE_NAME}/${localTheme}/images/home/home_challenge_icon.webp`,
        vsPlayerIconUrl: `${BASE_NAME}/${localTheme}/images/home/home-vs-player-icon.webp`,
        wordMakerIconUrl: `${BASE_NAME}/${localTheme}/images/home/home-word-marker-icon.webp`,
        leaderboardIconUrl: `${BASE_NAME}/${localTheme}/images/home/home_leaderboard_icon.webp`,
        profileBgPic: `${BASE_NAME}/${localTheme}/images/profile/profile-top-bg.webp`,
        profileEmptyImg: `${BASE_NAME}/${localTheme}/images/profile/profile-grey-img.webp`,
        leaderboardBgPicUrl: `${BASE_NAME}/${localTheme}/images/leaderboard/leaderboard-dialog-bg.webp`,
        leaderboardRecordCardBgUrl: `${BASE_NAME}/${localTheme}/images/leaderboard/record-card-bg.webp`,
        challengeWinStarPicUrl: `${BASE_NAME}/${localTheme}/images/challenge/ai-win-star.webp`,
        leaderboardListBgUrl: `${BASE_NAME}/${localTheme}/images/leaderboard/leaderboard-list-bg.webp`,
        rankIconUrl: `${BASE_NAME}/${localTheme}/images/leaderboard/rank-icon.webp`,
        rankFirstPicUrl: `${BASE_NAME}/${localTheme}/images/leaderboard/rang-first.webp`,
        rankSecondPicUrl: `${BASE_NAME}/${localTheme}/images/leaderboard/rank-second.webp`,
        rankThirdPicUrl: `${BASE_NAME}/${localTheme}/images/leaderboard/rank-third.webp`,
        leaderboardUpdatingPicUrl: `${BASE_NAME}/${localTheme}/images/leaderboard/leaderboard-updating-pic.webp`,
        defaultAvatarUrl: `${BASE_NAME}/${commonUrl}/images/default-avatar.webp`,
        logoImgUrl: `${BASE_NAME}/${commonUrl}/images/logo.webp`,
        logoTextImgUrl: `${BASE_NAME}/${commonUrl}/images/logo-text-pic.webp`,
        settingIconUrl: `${BASE_NAME}/${commonUrl}/images/setting-icon.webp`,
        downloadIconUrl: `${BASE_NAME}/${commonUrl}/images/download-icon.webp`,
        helpIconUrl: `${BASE_NAME}/${commonUrl}/images/help-icon.webp`,
        shareIconBlueUrl: `${BASE_NAME}/${commonUrl}/images/share-icon.webp`,
        leftTopBgUrl: `${BASE_NAME}/${commonUrl}/images/bg-left-top-icon.webp`,
        rightBottomBgUrl: `${BASE_NAME}/${commonUrl}/images/bg-right-bottom-icon.webp`,
        leftTopBgDialogUrl: `${BASE_NAME}/${commonUrl}/images/bg-dialog-left-top-icon.webp`,
        rightBottomBgDialogUrl: `${BASE_NAME}/${commonUrl}/images/bg-dialog-right-bottom-icon.webp`,
        switchBtnOpenUrl: `${BASE_NAME}/${commonUrl}/images/switch-btn-open.webp`,
        switchBtnCloseUrl: `${BASE_NAME}/${commonUrl}/images/switch-btn-close.webp`,
        logoutIconUrl: `${BASE_NAME}/${commonUrl}/images/logout-icon.webp`,
        closeBtnWhiteUrl: `${BASE_NAME}/${commonUrl}/images/close-icon-white.webp`,
        closerBtnGreyUrl: `${BASE_NAME}/${commonUrl}/images/close-icon-grey.webp`,
        goBackIconUrl: `${BASE_NAME}/${commonUrl}/images/back-btn.webp`,
        helpPicUrl: `${BASE_NAME}/${localTheme}/images/game/help-pic.webp`,
        tempProfileAvatar: `${BASE_NAME}/${localTheme}/images/home/avatar.webp`,
        tempProfileAvatar2: `${BASE_NAME}/${localTheme}/images/temp/avatar1.webp`,
        tempProfileAvatar3: `${BASE_NAME}/${localTheme}/images/temp/avatar2.webp`,
        tempProfileAvatar4: `${BASE_NAME}/${localTheme}/images/temp/avatar3.webp`,
        tempProfileAvatar5: `${BASE_NAME}/${localTheme}/images/temp/avatar_5.webp`,
        tempProfileAvatar6: `${BASE_NAME}/${localTheme}/images/temp/my_avatar.webp`,
        gamePageBgIconUrl: `${BASE_NAME}/${localTheme}/images/game/game_bg.webp`,
        gameBgSuccessIconUrl: `${BASE_NAME}/${localTheme}/images/game/game-success-bg.webp`,
        gameSuccessAvatarFlower: `${BASE_NAME}/${localTheme}/images/game/challenge-success-avatar-right-bottom-flower.webp`,
        gridNoDataImgUrl: `${BASE_NAME}/${localTheme}/images/game/game_grid_no_data_bg_word.webp`,
        firstKeyboardBtnUrl: `${BASE_NAME}/${localTheme}/images/game/keyboard_first_row_key_bg.webp`,
        secondKeyboardBtnUrl: `${BASE_NAME}/${localTheme}/images/game/keyboard_second_row_key_bg.webp`,
        thirdKeyboardBtnUrl: `${BASE_NAME}/${localTheme}/images/game/keyboard_third_row_key_bg.webp`,
        removeKeyboardBtnUrl: `${BASE_NAME}/${localTheme}/images/game/keyboard_remove_btn.webp`,
        hintKeyboardWhiteIconUrl: `${BASE_NAME}/${localTheme}/images/game/keyboard_hint_icon.webp`,
        hintKeyboardGreyIconUrl: `${BASE_NAME}/${localTheme}/images/game/keyboard_hint_icon_unable.webp`,
        letterAllWrongBgUrl: `${BASE_NAME}/${localTheme}/images/game/wrong_bg.webp`,
        gameDialogCardBgUrl: `${BASE_NAME}/${localTheme}/images/game/game-dialog-card-bg.webp`,
        aiChallengeDialogCardBgUrl: `${BASE_NAME}/${localTheme}/images/challenge/ai-challenge-dialog-card-bg.webp`,
        letterWrongPositionUrl: `${BASE_NAME}/${localTheme}/images/game/correct_letter_wrong_position_bg.webp`,
        letterAllRight: `${BASE_NAME}/${localTheme}/images/game/correct_letter_bg.webp`,
        clockIconUrl: `${BASE_NAME}/${localTheme}/images/game/clock_icon.webp`,
        mouseClickIconUrl: `${BASE_NAME}/${localTheme}/images/game/play_challenge_icon.webp`,
        challengeBgPic: `${BASE_NAME}/${localTheme}/images/challenge/challenge_bg_pic.webp`,
        challengeLogoUrl: `${BASE_NAME}/${localTheme}/images/challenge/challenge_icon.webp`,
        challengeTextPicUrl: `${BASE_NAME}/${localTheme}/images/challenge/challenge_text_logo.png`,
        youWinCardBgUrl: `${BASE_NAME}/${localTheme}/images/challenge/challenge-success-card-bg.webp`,
        dailyWinCardBgUrl: `${BASE_NAME}/${localTheme}/images/game/daily-game-success-card-bg.webp`,
        challengeLeftCardUrl: `${BASE_NAME}/${localTheme}/images/challenge/challenge-left.webp`,
        challengeRightCardUrl: `${BASE_NAME}/${localTheme}/images/challenge/challenge-right.webp`,
        challengeLightingIconUrl: `${BASE_NAME}/${localTheme}/images/challenge/lightning_icon.webp`,
        youWinTextPic: `${BASE_NAME}/${localTheme}/images/challenge/you-win-text-pic.webp`,
        aiTopBarAvatarUrl: `${BASE_NAME}/${localTheme}/images/challenge/game-ai-top-avatar-blue.webp`,
        challengeFailDialogAvatarLeft: `${BASE_NAME}/${localTheme}/images/challenge/challenge-fail-dialog-title-left-bg.webp`,
        challengeFailDialogAvatarRight: `${BASE_NAME}/${localTheme}/images/challenge/challenge-fail-dialog-right-bg.webp`,
        aiAvatarUrl: `${BASE_NAME}/${localTheme}/images/challenge/ai_avatar.webp`,
        rectangleIcon: `${BASE_NAME}/${commonUrl}/images/rectangle-icon.webp`,
        appleIconUrl: `${BASE_NAME}/${commonUrl}/images/apple-fill-icon.webp`,
        androidIconUrl: `${BASE_NAME}/${commonUrl}/images/android-fill-icon.webp`,
        arrowRightCircleIconUrl: `${BASE_NAME}/${commonUrl}/images/arrow-right-blue-circle.png`,
        greenPointIconUrl: `${BASE_NAME}/${commonUrl}/images/green-point.webp`,

        medalAddIconGrey: `${BASE_NAME}/${commonUrl}/images/medal-add-grey-icon.webp`,
        medalAddIconWhite: `${BASE_NAME}/${commonUrl}/images/medal-add-white-icon.webp`,
        medalDialogTopBg: `${BASE_NAME}/${commonUrl}/images/medal-dialog-top-bg.webp`,
        medalTopLeftPillar: `${BASE_NAME}/${commonUrl}/images/medal-top-left-pillar.webp`,
        medalTopMiddlePillar: `${BASE_NAME}/${commonUrl}/images/medal-top-middle-pillar.webp`,
        medalTopRightPillar: `${BASE_NAME}/${commonUrl}/images/medal-top-middle-pillar.webp`,

        skinExamplePic1: `${BASE_NAME}/${localTheme}/images/temp/skin-example-1.webp`,
        skinExamplePic2: `${BASE_NAME}/${localTheme}/images/temp/skin-example-2.webp`,
        medalTmp: `${BASE_NAME}/${localTheme}/images/temp/level1.webp`,
        shareWhiteIcon: `${BASE_NAME}/${commonUrl}/images/share-white-icon.webp`,
        copyWhiteIcon: `${BASE_NAME}/${commonUrl}/images/copy-white-icon.webp`,
        vsPlayWaitingTopIcon: `${BASE_NAME}/${commonUrl}/images/vs-player-waiting-top-logo-icon.webp`,
        vsPlayWaitingClockIcon: `${BASE_NAME}/${commonUrl}/images/vs-waiting-clock-icon.webp`,
        vsPlayShockingTextIcon: `${BASE_NAME}/${commonUrl}/images/vs-player-chocking-page-text.webp`,
        vsPlayMyMatchDialogBgPic: `${BASE_NAME}/${commonUrl}/images/vs-player-my-matches-dialog-bg-pic.webp`,
        vsPlayMyMatchCardBg: `${BASE_NAME}/${commonUrl}/images/vs-player-my-matched-card-bg.webp`,
        vsPlayMyMatchLeftBlueBg: `${BASE_NAME}/${commonUrl}/images/vs-player-matches-left-blue-bg.webp`,
        vsPlayMyMatchLeftGreyBg: `${BASE_NAME}/${commonUrl}/images/vs-player-matches-left-grey-bg.webp`,
        vsPlayMyMatchRightGreyBg: `${BASE_NAME}/${commonUrl}/images/vs-player-matches-right-grey-bg.webp`,
        vsPlayMyMatchRightPinkBg: `${BASE_NAME}/${commonUrl}/images/vs-player-matches-right-pink-bg.webp`,
        vsPlayWaitingPersonAddIcon: `${BASE_NAME}/${commonUrl}/images/vs-waiting-person-add-icon.webp`,
        vsPlayerModalLeftWinBg: `${BASE_NAME}/${localTheme}/images/vs-player/vs-player-dialog-left-win-bg.png`,
        vsPlayerModalLeftLoseBg: `${BASE_NAME}/${localTheme}/images/vs-player/vs-player-dialog-left-lose-bg.webp`,
        vsPlayerModalRightWinBg: `${BASE_NAME}/${localTheme}/images/vs-player/vs-player-dialog-right-win-bg.webp`,
        vsPlayerModalRightLoseBg: `${BASE_NAME}/${localTheme}/images/vs-player/vs-player-dialog-right-lose-bg.webp`,

        vsPlayTopIcon: `${BASE_NAME}/${commonUrl}/images/vs-player-top-icon.webp`,
        firstArrowRightIcon: `${BASE_NAME}/${localTheme}/images/vs-player/vs-player-first-arrow-right-icon.webp`,
        secondArrowRightIcon: `${BASE_NAME}/${localTheme}/images/vs-player/vs-player-second-arrow-right-icon.webp`,
        thirdArrowRightIcon: `${BASE_NAME}/${localTheme}/images/vs-player/vs-player-third-arrow-right-icon.webp`,
        vsPlayerEasyText: `${BASE_NAME}/${localTheme}/images/vs-player/vs-player-easy-text.webp`,
        vsPlayerMiddleText: `${BASE_NAME}/${localTheme}/images/vs-player/vs-player-medium-text.webp`,
        vsPlayerHardText: `${BASE_NAME}/${localTheme}/images/vs-player/vs-player-hard-text.webp`,
        avatarFrameCardBg: `${BASE_NAME}/${commonUrl}/images/avatar-frame-card-bg.webp`,
        profileAvatarLittleSwitchIcon: `${BASE_NAME}/${commonUrl}/images/little-switch-icon.webp`,
        awardDialogStarPic: `${BASE_NAME}/${commonUrl}/images/star-pic.webp`,
        awardDialogRayPic: `${BASE_NAME}/${commonUrl}/images/ray-pic.webp`,
        awardDialogTextPic: `${BASE_NAME}/${commonUrl}/images/congratulations-text.webp`,
        awardDialogRoundPic: `${BASE_NAME}/${commonUrl}/images/award-round_back.webp`,
        awardDialogQuartPic: `${BASE_NAME}/${commonUrl}/images/award_q_back.webp`,

        ugcHomeTopIcon: `${BASE_NAME}/${localTheme}/images/ugc/word-maker-top-icon.webp`,
        myPuzzlesDialogBg: `${BASE_NAME}/${localTheme}/images/ugc/my-puzzles-bg.webp`,
        ugcLikesGreyIcon: `${BASE_NAME}/${localTheme}/images/ugc/ugc-likes-icon-grey.webp`,
        ugcLikesBlueIcon: `${BASE_NAME}/${localTheme}/images/ugc/ugc-likes-icon-blue.webp`,
        ugcPlaysBlueIcon: `${BASE_NAME}/${localTheme}/images/ugc/ugc-play-num-icon-blue.webp`,
        ugcPlaysGreyIcon: `${BASE_NAME}/${localTheme}/images/ugc/ugc-play-num-icon-grey.webp`,
        ugcPlaysBlueUnFillIcon: `${BASE_NAME}/${localTheme}/images/ugc/ugc-like-blue-unFill-icon.webp`,
        ugcPlaysBlueFillIcon: `${BASE_NAME}/${localTheme}/images/ugc/ugc-like-blue-fill-icon.webp`,

        // 通用图标
        lockWhiteIcon: `${BASE_NAME}/${commonUrl}/icon/lock-white-icon.webp`,
        checkedBlueIcon: `${BASE_NAME}/${commonUrl}/icon/checked-icon-blue.webp`,
        arrowRightRoundWhiteIcon: `${BASE_NAME}/${commonUrl}/icon/arrow-right-round-white.png`,
        mouseWhiteIcon: `${BASE_NAME}/${commonUrl}/icon/mouse-click-white.png`,
        loginToSeeMore: `${BASE_NAME}/${commonUrl}/images/login-to-see-more-center-pic.webp`,
        themeImgTmp: `${BASE_NAME}/${localTheme}/images/temp/theme-tmp.png`,
    }

    const imgUrls = images;

    // 获取主题配置
    const loadThemeConfig = debounce(async () => {
        try {
            const response = await apiService.loadThemeSetting()
            if (response.code === 200) {
                setTheme(response.data)
                // 预加载主题配置的图片
                Object.keys(response.data).forEach((key) => {
                    const img = new Image();
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-expect-error
                    img.src = response.data[key];
                });
            } else {
                setTheme(null)
            }
        } catch (error) {
            console.error('Error fetching theme settings:', error);
            setTheme(null)
        }
    }, 100)

    // 预加载图片
    const preloadImages = (images: ThemeImgUrlType) => {
        Object.keys(images).forEach((key) => {
            const img = new Image();
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            img.src = images[key];
        });
    };

    // 从一开始就把所有的图片都加载一遍
    useEffect(() => {
        preloadImages(imgUrls)
    }, [])

    return (
        <ThemeContext.Provider value={{theme, loadThemeConfig, imgUrls}}>
            {children}
        </ThemeContext.Provider>
    );
}

export default ThemeProvider;